import * as React from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import InlineEditableField from '../../InlineEditableField';
import { removeErrorOnFocus } from '../../../common/util';
import Base from './base';

class Email extends Base {
    constructor(props) {
        super(props);
        this.state={
            email:null
        }
    }


    renderOnCard() {
        return (
            <div></div>
        )
    }
    renderOnGrid() {
        return (
            <div></div>
        )
    }
    renderOnDetail() {
        let { renderType, data, showLabel = false, openMail = false, returnValueForBlank = "-" } = this.props;
        if (Array.isArray(data))
            data = data[0];
        if (renderType.toLowerCase() === 'activity') {
            if (showLabel) {
                return (<li data-test={data.Label}><label>{data.Label}</label>
                    { <InlineEditableField
                        type="email"
                        data={data}
                        fieldValue={data.Value ? data.Value : returnValueForBlank}
                        canEdit={this.props.canEditActivity}
                        isCompositeField={false}
                        removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                        updateField={(data) => this.props.updateActivityField(data)} />}
                </li>)
            }
            else {
                return (<li data-test={data.Value}><p className="email">{data.Value ? data.Value : returnValueForBlank}</p></li>)
            }
        } else if (renderType.toLowerCase() === 'workkard') {
            if (showLabel) {
                //(<li data-test={data.Label}><label>{data.Label} </label><a className={`${openMail && data.Value ?'pointer email':'black email'}`} onClick={() => { (openMail && data.Value && data.Value.trim()) ? window.location.href = `mailto:${data.Value}` : null }}>{data.Value && data.Value.trim()?data.Value:returnValueForBlank}</a></li>)
                return (<li data-test={data.Label}>
                    <label data-field-label={this.props.isShowDetailOnPopUp ? data.FieldKey + "label_block" : data.FieldKey}>{data.Label} </label>
                    {(this.props.dragndrop || !this.props.isShowDetailOnPopUp) ?
                        (<span>{data.Value && data.Value.trim() ? data.Value : returnValueForBlank}</span>)
                        : <InlineEditableField
                            type="email"
                            data={data}
                            canEdit={this.props.canEditWorkkard}
                            isCompositeField={false}
                            fieldValue={data.Value && data.Value.trim() ? data.Value : returnValueForBlank}
                            removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                            updateField={(data) => this.props.updateWorkkardFieldInfo(data)} />

                    }
                </li>);

            } else {
                return (data.Value && data.Value.trim() ? data.Value : returnValueForBlank);
            }
        } else {
            return (showLabel) ?
                (<React.Fragment><label>{data.Label}: </label><p className="email">{data.Value ? data.Value : returnValueForBlank}</p></React.Fragment>)
                :
                (data.Value ? data.Value : returnValueForBlank)
        }
    }

    renderOnCreate() {
        let { renderType, data, showLabel = false } = this.props;
        if (renderType.toLowerCase() === 'note') {
            return (showLabel) ?
                (<div>
                    <label>{data.Label}{data.IsMandatory ? <span className="red">*</span> : ""} </label>
                    <div className="FieldBlock string">
                        <input type="text" id={data.FieldKey} name={data.FieldKey} placeholder={data.Label} value={(this.state.email==null && data.Value!=null && data.Value!='') ? this.setState({email:data.Value}):this.state.email} onFocus={(e)=>removeErrorOnFocus(e)} onChange={(e) =>{this.setState({email:e.target.value}); this.props.onFieldValueChange(e.target)}} />
                        <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
                    </div>
                </div>)
                :
                (<div>{data.Value}</div>)
        }
        return ""
    }

}

export default Email;